<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "GlobalLayoutView",
};
</script>

<style lang="scss" scoped></style>
